<script lang="ts">
    import { portal } from 'svelte-portal';
    import TitleMenu from './components/title-menu.svelte';

    import descriptionImg from '@src/assets/img/gi_description.webp';
    import welcomeImg from '@src/assets/img/gi_welcome.webp';
    import chipImg from '@src/assets/img/gi_chip.webp';
    import rebetImg from '@src/assets/img/gi_rebet.webp';
    import doubleImg from '@src/assets/img/gi_double.webp';
    import undoImg from '@src/assets/img/gi_undo.webp';
    import autoplayImg from '@src/assets/img/gi_autoplay.webp';
    import leftInbetweenImg from '@src/assets/img/gi_left_inbetween.webp';
    import rightInbetweenImg from '@src/assets/img/gi_right_inbetween.webp';

    const titleClass = 'text-xl !font-bold text-center desktop:!text-2xl mb-1';
    const descClass = 'text-md leading-6 text-cross-t-body';
    const sectionClass = 'mt-4 flex flex-col tablet:mt-6';
    const imgClass = 'max-w-sm py-2';
    const imgClassFull = 'max-w-xl py-2';
    const titleGame = document.title;
</script>

<div
    class="fixed bottom-7 h-8 w-full bg-gradient-black tablet:bottom-12 desktop:bottom-0 desktop:h-16 desktop:rounded-b-3xl"
    use:portal={'#portal-gradient-game-info'}
/>

<div class="relative h-full w-full overflow-hidden !pb-16 !font-Roboto text-white">
    <TitleMenu class="!mb-6 text-center !text-2xl tablet:!text-4xl">About the game</TitleMenu>
    <p class={descClass}>
        {titleGame} is a game based on pre-recorded video streaming of a physical claw machine with randomized movement with
        elements of Live show logic.<br />
        The objective of the game is to correctly predict the ball which will be pulled out by claw. By predicting the right
        ball, the Player earns a payout of their bet.
    </p>

    <section class={sectionClass}>
        <h3 class={titleClass}>How to play</h3>
        <p class={descClass}>
            In Crazy Crazy Claw, bets must be placed on the layout that display eight available betting positions
            corresponding to the balls inside Claw Machine.<br />
            To start playing, select the value of the chip you would like to wager on a given spin and place on the appropriate
            betting option(s) on the layout.<br />
            You total bet will be displayed in the “Total Bet” window.<br />
            When you press play button, bonus reels will spin after which claw will start pulling out one random ball, if
            any of your bets are covering betting option corresponding to the pulled ball, you receive winning returns according
            to the winning ball odds as described in “Bets and Payouts” section. The amount will be shown in the win message
            in the center of the screen and will include your initial bet.
        </p>
    </section>

    <section class={sectionClass}>
        <h3 class={titleClass}>Bets and Payouts</h3>
        <p class={descClass}>
            You may place wagers on any of eight options (1, 2, 5, 10, Spin the Ball, Plinko, Cash Reels, Wheel of
            Fortune) corresponding ball of which will be pulled in your opinion.<br />
        </p>
        <ul class={descClass}>
            <li>Win if corresponding ball is pulled out.</li>
            <li>Lose if any other ball is pulled out</li>
        </ul>
        <p class={descClass}>
            You may cover all eight bet options in the same game round.<br />
            In Crazy Crazy Claw the following payouts are offered:
        </p>
    </section>

    <section class={sectionClass}>
        <div class="flex justify-center">
            <img
                class={'w-full max-w-sm ' + imgClassFull}
                srcset={`${descriptionImg} 1x, ${descriptionImg} 2x`}
                alt=""
                loading="lazy"
            />
        </div>
        <p class={descClass}>
            Depending on whichever of the following two is reached firts, the maximum possible payout in this game is
            4999:1 ( 5000x ) or currency equivalent of € 250,000.<br />
            Maximum Total Bet between all betting fields is currency equivalent of €5000
        </p>
    </section>

    <section class={sectionClass}>
        <h3 class={titleClass}>Bonus Reels</h3>
        <div class="flex justify-center">
            <img
                class={'w-full max-w-sm ' + imgClassFull}
                srcset={`${welcomeImg} 1x, ${welcomeImg} 2x`}
                alt=""
                loading="lazy"
            />
        </div>
        <p class={descClass}>The game has a Bonus Reels consisting of two reels</p>
        <ul class={descClass}>
            <li>The left one shows the multiplier that will be applied to the result on the right</li>
            <li>The right one shows the outcome of the round to which it will be applied</li>
            <li>Possible multipliers are from x1 to x50</li>
            <li>Right one rolls one of the 8 betting options.</li>
        </ul>
    </section>

    <section class={sectionClass}>
        <h3 class={titleClass}>Spin the Ball</h3>
        <p class={descClass}>When “Spin the Ball” ball will be pulled out by the Claw, these steps will occur:</p>
        <ul class={descClass}>
            <li>The player enters the Spin the Ball bonus game</li>
            <li>The game shows him 2 multipliers: small and large.</li>
            <ul class={descClass}>
                <li>Small multiplier rolls between x2 - x5</li>
                <li>Large multiplier rolls between x7 - x100</li>
                <li>
                    If Bonus Reels falls on this bonus before its launch, then the multipliers will be increased by
                    Multiplier from Bonus reels times
                </li>
            </ul>
            <li>The two-colored ball in the center spins</li>
            <ul class={descClass}>
                <li>The ball will stop at one of two colors.</li>
                <li>A multiplier of the corresponding color will be paid to the player</li>
            </ul>
        </ul>
    </section>

    <section class={sectionClass}>
        <h3 class={titleClass}>Placing bets</h3>
        <div class="mb-2 flex items-start justify-center rounded-lg bg-rules-gray p-4">
            <div class="mr-4 flex items-center justify-center">
                <img src={chipImg} alt="" class="max-w-xs" />
            </div>
            <div class="flex items-start">
            </div>
        </div>
        <div class="mb-2 flex items-start justify-center rounded-lg bg-rules-gray p-4">
            <div class="mr-4 flex items-center justify-center">
                <img src={rebetImg} alt="" class="max-w-xs" />
            </div>
            <div class="flex items-start">
            </div>
        </div>
        <div class="mb-2 flex items-start justify-center rounded-lg bg-rules-gray p-4">
            <div class="mr-4 flex items-center justify-center">
                <img src={doubleImg} alt="" class="max-w-xs" />
            </div>
            <div class="flex items-start">
                <p class="flex items-start">
                    Clicking the Double button doubles the number of chipls that you have placed on an available bet
                    fields. With every click it doubles your bet.
                </p>
            </div>
        </div>
        <div class="mb-2 flex items-start justify-center rounded-lg bg-rules-gray p-4">
            <div class="mr-4 flex items-center justify-center">
                <img src={undoImg} alt="" class="max-w-xs" />
            </div>
            <div class="flex items-start">
                <p class="flex items-start">
                    Clicking the Undo button removes the last bet you placed. Repeatedly clicking the Undo button
                    removes bets one by one, with the most recent bet(s) removed first.
                </p>
            </div>
        </div>
        <div class="mb-2 flex items-start justify-center rounded-lg bg-rules-gray p-4">
            <div class="mr-4 flex items-center justify-center">
                <img src={autoplayImg} alt="" class="max-w-xs" />
            </div>
            <div class="flex items-start">
            </div>
        </div>
        <div class="mb-2 flex items-start justify-center rounded-lg bg-rules-gray p-4">
            <div class="mr-4 flex items-center justify-center">
                <img src={leftInbetweenImg} alt="" class="max-w-xs" />
            </div>
            <div class="flex items-start">
                <p class="flex items-start">
                    Clicking Left Inbetween button on the betting fields will place selected chip to all adjacent
                    betting fields (i.e. in this case on x1, x2, x5 and x10).
                </p>
            </div>
        </div>
        <div class="mb-2 flex items-start justify-center rounded-lg bg-rules-gray p-4">
            <div class="mr-4 flex items-center justify-center">
                <img src={rightInbetweenImg} alt="" class="max-w-xs" />
            </div>
            <div class="flex items-start">
                <p class="flex items-start">
                    Clicking Right Inbetween button on the betting fields will place selected chip to all adjacent
                    betting fields (i.e. in this case on Spin the Ball, Plinko, Cash Reels, Wheel of Fortune).
                </p>
            </div>
        </div>
        <p class={descClass}>
            The Balance Indicator shows your available funds and the currency. it is always displayed in the bottom of
            the game window.
        </p>
        <p class={descClass}>
            The Total Bet indicator shows the current total of all bets placed. It is always displayed at the bottom of
            the game window.
        </p>
    </section>

    <section class={sectionClass}>
        <h3 class={titleClass}>History line</h3>
        <p class={descClass}>History line shows the most recent outcomes.</p>
    </section>

    <section class={sectionClass}>
        <h3 class={titleClass}>Game Options</h3>
        <ul class={descClass}>
            <li>Tap the options icon to open options menu;</li>
            <li>Info – Opens the game rules which explains game payouts, features and other information;</li>
            <li>Game Settings – Changes the game volume, and other settings;</li>
            <li>Mute – Turns the sounds on or off.</li>
        </ul>
    </section>

    <section class={sectionClass}>
        <h3 class={titleClass}>Return to Player (RTP)</h3>
        <ul class={descClass}>
            <li>The optimal theoretical RTP is 96.10% ( min 96.08% - max 96.10% )</li>
            <li>The max win relative to the combined bet is 5 000x or currency equivalent € 250,000.</li>
        </ul>
    </section>

    <section class={sectionClass}>
        <h3 class={titleClass}>Additional Information</h3>
        <ul class={descClass}>
            <li>
                In the event of a malfunction of the gaming hardware/software, all affected game bets and payouts are
                rendered void and all affected bets are refunded.
            </li>
        </ul>
    </section>
</div>

<style>
    .section {
        font-weight: 600;
        font-size: 16px;
        text-decoration-line: underline;
        text-transform: capitalize;
        margin: 24px 0 12px;
    }

    ul {
        list-style-type: disc;
        padding-left: 1.5em;
    }
</style>
